import { render, staticRenderFns } from "./MinisiteItemClassificationResult.vue?vue&type=template&id=40b363c4&"
import script from "./MinisiteItemClassificationResult.vue?vue&type=script&lang=js&"
export * from "./MinisiteItemClassificationResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b363c4')) {
      api.createRecord('40b363c4', component.options)
    } else {
      api.reload('40b363c4', component.options)
    }
    module.hot.accept("./MinisiteItemClassificationResult.vue?vue&type=template&id=40b363c4&", function () {
      api.rerender('40b363c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisiteItemClassificationResult.vue"
export default component.exports